import { alocacao as enUS_alocacao } from './en-US/alocacao';
import { auth as enUS_auth } from './en-US/auth';
import { common as enUS_common } from './en-US/common';
import { projetos as enUS_projetos } from './en-US/projetos';
import { tagsAlocacao as enUS_tagsAlocacao } from './en-US/tagsAlocacao';
import { alocacao as ptBR_alocacao } from './pt-BR/alocacao';
import { auth as ptBR_auth } from './pt-BR/auth';
import { common as ptBR_common } from './pt-BR/common';
import { projetos as ptBR_projetos } from './pt-BR/projetos';
import { tagsAlocacao as ptBR_tagsAlocacao } from './pt-BR/tagsAlocacao';

export const resources = {
  'pt-BR': {
    common: ptBR_common,
    auth: ptBR_auth,
    alocacao: ptBR_alocacao,
    tagsAlocacao: ptBR_tagsAlocacao,
    projetos: ptBR_projetos,
  },
  'en-US': {
    common: enUS_common,
    auth: enUS_auth,
    alocacao: enUS_alocacao,
    tagsAlocacao: enUS_tagsAlocacao,
    projetos: enUS_projetos,
  },
} as const;

export const defaultNS = 'common' as const;
export const supportedLanguages = ['pt-BR', 'en-US'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];
